module.exports = __webpack_public_path__ + "static/media/coverPic.3797dc8f.jpg";